import { createReducer, on } from '@ngrx/store';
import { initialUserState } from '../states/user.state';
import * as UserActions from '../actions/user.action';



export const userReducer = createReducer(
    initialUserState,
    on(UserActions.changed, (state, changes) => ({
        ...state,
        ...changes
    })),
    on(UserActions.changedSettings, (state, { settings }) => ({
        ...state,
        current: {
            ...state.current,
            user_settings: settings
        }
    })),
    on(UserActions.connectCalendar, (state) => ({
        ...state,
        current: {
            ...state.current,
            user_settings: {
                ...state.current.user_settings,
                calendarLoad: {
                    ...state.current.user_settings.calendarLoad,
                    connecting: true
                }
            }
        }
    })),
    on(UserActions.connectCalendarSuccess, UserActions.connectCalendarFailure, (state) => ({
        ...state,
        current: {
            ...state.current,
            user_settings: {
                ...state.current.user_settings,
                calendarLoad: {
                    ...state.current.user_settings.calendarLoad,
                    connecting: false
                }
            }
        }
    })),
    on(UserActions.disconnectCalendar, (state) => ({
        ...state,
        current: {
            ...state.current,
            user_settings: {
                ...state.current.user_settings,
                calendarLoad: {
                    ...state.current.user_settings.calendarLoad,
                    disconnecting: true
                }
            }
        }
    })),
    on(UserActions.reconnectCalendar, (state) => ({
      ...state,
      current: {
        ...state.current,
        user_settings: {
          ...state.current.user_settings,
          calendarLoad: {
            ...state.current.user_settings.calendarLoad,
            reconnecting: true
          }
        }
      }
    })),
    on(UserActions.disconnectCalendarSuccess, UserActions.disconnectCalendarFailure, (state) => ({
        ...state,
        current: {
            ...state.current,
            user_settings: {
                ...state.current.user_settings,
                calendarLoad: {
                    ...state.current.user_settings.calendarLoad,
                    disconnecting: false,
                }
            }
        }
    }))
);
